import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useMaskedInput from "../../hooks/useMaskedInput";

export default function Step4Details() {
  const navigate = useNavigate();
  const [storeCode, setStoreCode] = useState("GEPPRO20");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const supportEmail = useMaskedInput("", "email");
  const contactPhone = useMaskedInput("", "phone");

  const handleGenerateCode = () => {
    const newCode = "LOJA" + Math.floor(Math.random() * 900 + 100);
    setStoreCode(newCode);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    try {
      const { saveStepData } = require("../../services/storeCreationService");
      saveStepData("step4", {
        storeCode,
        description,
        category,
        supportEmail: supportEmail.value,
        contactPhone: contactPhone.value,
      });
    } catch {}
    navigate("/create-store/step5");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white px-4">
      <div className="w-full max-w-lg space-y-6 pt-10 pb-10">
        <div className="space-y-2">
          <button type="button" onClick={() => navigate(-1)} className="text-gray-600">&larr;</button>
          <h1 className="text-xl font-bold text-gray-800">Criar loja</h1>
          <h2 className="text-xl font-bold text-gray-800">
            Detalhe as informações
          </h2>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Código personalizado da loja
              <span className="text-red-500">*</span>
            </label>
            <div className="flex space-x-2">
              <input
                type="text"
                value={storeCode}
                onChange={(e) => setStoreCode(e.target.value)}
                className="mt-1 flex-1 border border-gray-300 rounded-lg px-3 py-2 focus:ring-purple-500 focus:border-purple-500"
                placeholder="GEPPRO20"
              />
              <button
                type="button"
                onClick={handleGenerateCode}
                className="mt-1 bg-purple-600 text-white py-2 px-4 rounded-lg font-semibold hover:bg-purple-700 transition"
              >
                Gerar
              </button>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Descrição da loja<span className="text-red-500">*</span>
            </label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows="4"
              className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-purple-500 focus:border-purple-500 resize-none"
              placeholder="Destaque os pontos positivos da sua loja"
            ></textarea>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Categoria principal de atuação
              <span className="text-red-500">*</span>
            </label>
            <select
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 bg-white focus:ring-purple-500 focus:border-purple-500 appearance-none"
            >
              <option value="">Selecione a categoria</option>
              <option value="Comidas e Bebidas">Comidas e Bebidas</option>
              <option value="Vestuário">Vestuário</option>
              <option value="Eletrônicos">Eletrônicos</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Email de suporte ao cliente<span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              value={supportEmail.value}
              onChange={supportEmail.onChange}
              className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-purple-500 focus:border-purple-500"
              placeholder="empresa@suporte.com"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Telefone de contato<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={contactPhone.value}
              onChange={contactPhone.onChange}
              className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-purple-500 focus:border-purple-500"
              placeholder="(99) 99999-9999"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-purple-400 text-white py-3 rounded-lg font-semibold hover:bg-purple-500 transition"
          >
            Prosseguir
          </button>
        </form>
      </div>
    </div>
  );
}
